<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-8 col-md-7 col-7 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">POS STAFF</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-5 col-5 d-flex justify-content-end">
        <material-button
          @click="addStaff()"
          :disabled="disableBtnSubmit"
          class="mx-2 btn-background btn-sm"
        >
          Add new staff
        </material-button>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row my-3 d-flex align-items-left">
          <div class="col-lg-6 col-md-6 col-12">
            <input
              class="nosubmit"
              type="search"
              id="keyword_search"
              v-model="searchKeyword"
              extraClass
              name="keyword_search"
              placeholder="Search by staff id, name, phone"
              @input="onChangesearchKeyword"
            />
          </div>
        </div>
        <div class="row">
          <div class="notifications">
            <material-alert
              v-if="error"
              color="danger"
              icon="ni ni-like-2 ni-lg"
              dismissible
            >
              {{ error }}
            </material-alert>
          </div>
          <div class="col-lg-12 col-md-12 col-12 mx-auto" v-if="isLoadData">
            <div class="row mt-4">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder w-5">
                              No.
                            </th>
                            <th class="text-center font-weight-bolder w-20">
                              ID
                            </th>
                            <th class="text-center font-weight-bolder w-20">
                              Name
                            </th>
                            <th class="text-center font-weight-bolder w-20">
                              Job Title
                            </th>
                            <th class="text-center font-weight-bolder w-20">
                              Staff Type
                            </th>
                            <th class="text-center font-weight-bolder w-20">
                              Phone Number
                            </th>
                            <th class="text-center font-weight-bolder w-20">
                              Status
                            </th>
                            <th class="text-center font-weight-bolder w-15">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="staffs.length">
                          <tr v-for="(value, key) in staffs" :key="key">
                            <td class="text-center text-xss">
                              {{ value.id }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.staff_id }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.name }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.job_title }}
                            </td>
                            <td class="text-center text-xss">
                              {{
                                Number(value.is_internal_only) === 1
                                  ? "Internal Only"
                                  : "Normal"
                              }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.phone_number }}
                            </td>
                            <td class="align-middle text-center w-10">
                              <span
                                class="badge badge-sm"
                                v-bind:class="
                                  value.status == 1
                                    ? 'bg-gradient-success'
                                    : 'bg-danger'
                                "
                              >
                                {{
                                  value.status == 1 ? "Active" : "Inactive"
                                }}</span
                              >
                            </td>
                            <td class="align-middle text-center text-sm">
                              <a
                                class="btn btn-link text-dark px-3 mb-0"
                                @click="editStaff(value.id)"
                              >
                                <i
                                  class="fas fa-pencil-alt text-dark me-2"
                                  aria-hidden="true"
                                ></i
                                >Edit
                              </a>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="8" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                  <div class="text-center mt-2 d-flex justify-content-end">
                    <div class="dropdown">
                      <button
                        class="btn btn-secondary dropdown-toggle btn-sm"
                        type="button"
                        id="dropdownMenuButton1"
                        style="margin-top: 13px"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        aria-haspopup="true"
                      >
                        Download
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item"
                            @click="exportFile('csv')"
                            href="#"
                            >Export CSV</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            @click="exportFile('xlsx')"
                            href="#"
                            >Export Excel</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalConfirm
        message="Are you sure you want to delete ?"
        :process-yes="processYes"
      />
      <div class="position-fixed top-1 end-1 z-index-9999 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
      <form
        :action="`${actionDownload}/merchant/download-staffs`"
        method="POST"
      >
        <input type="hidden" name="merchantId" :value="merchantIdExport" />
        <input type="hidden" name="merchant_code" :value="merchantCodeExport" />
        <input type="hidden" name="search_keyword" :value="searchKeyword" />
        <input type="hidden" name="token" :value="token" />
        <input type="hidden" name="action_export" :value="action_export" />
        <input type="hidden" name="action" value="export" />
        <input id="downloadForm" type="submit" class="d-none" />
      </form>

      <div>
        <button
          style="display: none"
          type="button"
          id="action-group"
          data-bs-toggle="modal"
          data-bs-target="#modalEdit"
        ></button>
        <div class="modal fade" id="modalEdit" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ labelGroup }}</h5>
              </div>
              <div class="modal-body">
                <div class="row d-flex bd-highlight">
                  <div class="col-lg-4 col-4 align-self-center">
                    ID<span class="text-danger ms-2">*</span>
                  </div>
                  <div
                    class="col-lg-8 col-8 d-flex bd-highlight d-flex justify-content-end"
                  >
                    <material-input
                      v-model="dataStaff.staff_id"
                      extraClass="ml-5"
                      placeholder="Enter staff id"
                    />
                  </div>
                </div>
                <div
                  class="row d-flex bd-highlight"
                  v-if="fieldRequired.isStaffIdRequire"
                >
                  <div class="col-lg-4 col-4 align-self-center"></div>
                  <div class="col-lg-8 col-8 d-flex bd-highlight">
                    <span class="is-invalid">{{
                      textRequireStaffIdCustom
                    }}</span>
                  </div>
                </div>
                <div class="row d-flex bd-highlight">
                  <div class="col-lg-4 col-4 align-self-center">
                    Name<span class="text-danger ms-2">*</span>
                  </div>
                  <div
                    class="col-lg-8 col-8 d-flex bd-highlight d-flex justify-content-end"
                  >
                    <material-input
                      v-model="dataStaff.name"
                      extraClass="ml-5"
                      placeholder="Enter staff name"
                    />
                  </div>
                </div>
                <div
                  class="row d-flex bd-highlight"
                  v-if="fieldRequired.isStaffNameRequire"
                >
                  <div class="col-lg-4 col-4 align-self-center"></div>
                  <div class="col-lg-8 col-8 d-flex bd-highlight">
                    <span class="is-invalid">{{
                      textRequireStaffNameCustom
                    }}</span>
                  </div>
                </div>
                <!-- SH008 — salon service staff setup -->
                <div class="row d-flex bd-highlight pt-2">
                  <div class="col-lg-4 col-4 align-self-center">Job Title</div>
                  <div
                    class="col-lg-8 col-8 d-flex bd-highlight d-flex justify-content-end"
                  >
                    <material-input
                      v-model="dataStaff.job_title"
                      extraClass="ml-5"
                      placeholder="e.g. Senior Stylist"
                    />
                  </div>
                </div>
                <!-- SH036 — who the staff member is offered to -->
                <div class="row d-flex bd-highlight pt-2">
                  <div class="col-lg-4 col-4 align-self-center">
                    Staff Type
                    <span class="fs-12 d-block"
                      >Internal only staff are not shown to customers.</span
                    >
                  </div>
                  <div class="col-lg-8 col-8 d-flex bd-highlight d-flex">
                    <MaterialRadio
                      id="is_internal_only_0"
                      name="is_internal_only"
                      value="0"
                      class="ps-0"
                      v-model="dataStaff.is_internal_only"
                    >
                      Normal
                    </MaterialRadio>
                    <MaterialRadio
                      id="is_internal_only_1"
                      name="is_internal_only"
                      value="1"
                      v-model="dataStaff.is_internal_only"
                    >
                      Internal Only
                    </MaterialRadio>
                  </div>
                </div>
                <div class="row d-flex bd-highlight pt-3">
                  <div class="col-lg-4 col-4">Photo</div>
                  <div class="col-lg-8 col-8">
                    <div class="d-flex align-items-center gap-3">
                      <img
                        v-if="imagePreview"
                        :src="imagePreview"
                        class="staff-photo-preview"
                        alt="Staff photo"
                      />
                      <div class="d-flex flex-column">
                        <input
                          ref="staffPhoto"
                          type="file"
                          accept="image/*"
                          class="form-control form-control-sm"
                          @change="onPhotoChange"
                        />
                        <a
                          v-if="imagePreview"
                          class="text-danger fs-12 mt-1"
                          href="#"
                          @click.prevent="removePhoto"
                          >Remove photo</a
                        >
                      </div>
                    </div>
                    <span v-if="messageImageError" class="is-invalid">{{
                      messageImageError
                    }}</span>
                  </div>
                </div>
                <!-- SH029 — the work schedule, drawn like the sale channel's own
                     Operating Hours table so a merchant reads one shape in both places. -->
                <div class="row d-flex bd-highlight pt-3">
                  <div class="col-lg-4 col-4">
                    Work Schedule
                    <span class="fs-12 d-block"
                      >Always within the sale channel's opening hours.</span
                    >
                  </div>
                  <div class="col-lg-8 col-8">
                    <div class="table-responsive">
                      <table class="table align-items-center mb-0 work-schedule-table">
                        <thead>
                          <tr>
                            <th class="text-start font-weight-bolder col-day">
                              Day
                            </th>
                            <th class="text-start font-weight-bolder col-type">
                              Period Type
                            </th>
                            <th class="text-start font-weight-bolder">Period</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(day, dayIndex) in dataStaff.work_schedule"
                            :key="day.day_of_week"
                          >
                            <td class="text-start align-middle">
                              {{ day.day_name }}
                            </td>
                            <td class="text-start align-middle">
                              <Multiselect
                                v-model="day.period_type"
                                :options="periodTypes"
                                :canClear="false"
                                :canDeselect="false"
                                placeholder="Select period"
                              />
                            </td>
                            <td
                              class="text-start ps-3 align-middle"
                              v-if="day.period_type === PERIOD.WORK_PERIOD"
                            >
                              <div
                                v-for="(hour, hourIndex) in day.work_hours"
                                :key="hourIndex"
                                class="d-flex align-items-center flex-wrap mb-1 gap-1"
                              >
                                <input
                                  type="time"
                                  class="work-time"
                                  v-model="hour.start_time"
                                />
                                <span>-</span>
                                <input
                                  type="time"
                                  class="work-time"
                                  v-model="hour.end_time"
                                />
                                <i
                                  class="material-icons opacity-10 ms-1 text-danger cursor-pointer"
                                  @click="removeWorkPeriod(dayIndex, hourIndex)"
                                  >remove</i
                                >
                              </div>
                              <div
                                class="cursor-pointer"
                                @click="addWorkPeriod(dayIndex)"
                              >
                                <i class="material-icons opacity-10 text-info"
                                  >add</i
                                >
                              </div>
                              <span
                                v-if="workScheduleErrorDay === day.day_of_week"
                                class="is-invalid d-block"
                                >{{ textRequireWorkScheduleCustom }}</span
                              >
                            </td>
                            <td class="text-start ps-3 align-middle" v-else>
                              N/A
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- SH030 — which services this staff member can perform. Nothing ticked
                     is the normal state and means no restriction at all, so the section
                     says that out loud rather than looking like an empty setup. -->
                <div class="row d-flex bd-highlight pt-3">
                  <div class="col-lg-4 col-4">
                    Services
                    <span class="fs-12 d-block"
                      >What this staff member can perform.</span
                    >
                  </div>
                  <div class="col-lg-8 col-8">
                    <div
                      class="d-flex align-items-center justify-content-between flex-wrap gap-1 mb-2"
                    >
                      <span
                        class="fs-12"
                        :class="
                          selectedServiceCount ? 'text-dark' : 'staff-service-hint'
                        "
                      >
                        <template v-if="selectedServiceCount">
                          {{ selectedServiceCount }} of
                          {{ totalServiceCount }} services selected
                        </template>
                        <template v-else>
                          No restriction — can perform all services
                        </template>
                      </span>
                      <a
                        v-if="selectedServiceCount"
                        class="fs-12 text-danger"
                        href="#"
                        @click.prevent="clearServices"
                        >Clear all</a
                      >
                    </div>
                    <!-- The first step: which menu set to pick from. Held here rather
                         than fetched per set — the whole catalogue arrived in one call. -->
                    <Multiselect
                      v-if="menuSetOptions.length"
                      v-model="selectedSetId"
                      :options="menuSetOptions"
                      :canClear="false"
                      :canDeselect="false"
                      :searchable="menuSetOptions.length > 8"
                      class="mb-2"
                      placeholder="Select a menu set"
                      @change="onMenuSetChange"
                    />
                    <input
                      v-if="selectedSetId && hasServicesInSet"
                      v-model="serviceSearch"
                      type="text"
                      class="form-control form-control-sm mb-2"
                      placeholder="Search services"
                    />
                    <div v-if="isLoadingServices" class="fs-12 staff-service-hint">
                      Loading services…
                    </div>
                    <div
                      v-else-if="!menuSetOptions.length"
                      class="fs-12 staff-service-hint"
                    >
                      This merchant has no menu set yet.
                    </div>
                    <div v-else-if="!selectedSetId" class="fs-12 staff-service-hint">
                      Choose a menu set to see its services.
                    </div>
                    <div v-else-if="!hasServicesInSet" class="fs-12 staff-service-hint">
                      This menu set has no services yet.
                    </div>
                    <div v-else-if="!serviceGroups.length" class="fs-12 staff-service-hint">
                      No service matches that search.
                    </div>
                    <div v-else class="staff-service-list">
                      <div
                        v-for="group in serviceGroups"
                        :key="group.name"
                        class="staff-service-group"
                      >
                        <div
                          class="d-flex align-items-center justify-content-between staff-service-group-head"
                        >
                          <span class="font-weight-bolder">{{
                            group.name || "Uncategorised"
                          }}</span>
                          <a
                            class="fs-12"
                            href="#"
                            @click.prevent="toggleGroup(group)"
                            >{{
                              isGroupSelected(group) ? "Clear" : "Select all"
                            }}</a
                          >
                        </div>
                        <div
                          v-for="service in group.services"
                          :key="service.item_id"
                          class="form-check staff-service-row"
                        >
                          <input
                            :id="'staff-service-' + service.item_id"
                            class="form-check-input"
                            type="checkbox"
                            :checked="isServiceSelected(service.item_id)"
                            @change="toggleService(service.item_id)"
                          />
                          <label
                            class="custom-control-label"
                            :for="'staff-service-' + service.item_id"
                          >
                            {{ service.name }}
                            <span
                              v-if="service.duration_min"
                              class="fs-12 staff-service-hint"
                              >· {{ service.duration_min }} min</span
                            >
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row d-flex bd-highlight pt-3">
                  <div class="col-lg-4 col-4 align-self-center">
                    Gap Between Appointments
                    <span class="fs-12 d-block"
                      >Minutes. Leave blank to use the sale channel's.</span
                    >
                  </div>
                  <div
                    class="col-lg-8 col-8 d-flex bd-highlight d-flex justify-content-end"
                  >
                    <material-input
                      v-model="dataStaff.appointment_gap_min"
                      type="number"
                      extraClass="ml-5"
                      placeholder="Inherit from sale channel"
                    />
                  </div>
                </div>
                <div class="row d-flex bd-highlight pt-2">
                  <div class="col-lg-4 col-4 align-self-center">
                    Phone Number<span class="text-danger ms-2">*</span>
                  </div>
                  <div
                    class="col-lg-8 col-8 d-flex bd-highlight d-flex justify-content-end"
                  >
                    <material-input
                      v-model="dataStaff.phone_number"
                      extraClass="ml-5"
                      placeholder="Enter staff phone no"
                    />
                  </div>
                </div>
                <div
                  class="row d-flex bd-highlight"
                  v-if="fieldRequired.isStaffPhoneNoRequire"
                >
                  <div class="col-lg-4 col-4 align-self-center"></div>
                  <div class="col-lg-8 col-8 d-flex bd-highlight">
                    <span class="is-invalid">{{
                      textRequireStaffPhoneNoCustom
                    }}</span>
                  </div>
                </div>
                <div class="row d-flex bd-highlight pt-2">
                  <div class="col-lg-4 col-4 align-self-center">Status</div>
                  <div class="col-lg-8 col-8 d-flex bd-highlight d-flex">
                    <MaterialRadio
                      id="status_1"
                      value="1"
                      class="ps-0"
                      v-model="dataStaff.status"
                    >
                      Active
                    </MaterialRadio>
                    <MaterialRadio
                      id="status_2"
                      value="0"
                      v-model="dataStaff.status"
                    >
                      Inactive
                    </MaterialRadio>
                  </div>
                </div>
              </div>
              <!-- Modal content-->
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-success btn-background btn-sm"
                  @click="saveStaff"
                >
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-close-modal btn-sm"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import "bootstrap/js/dist/modal";
import MaterialButton from "@/components/MaterialButton.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import ModalConfirm from "@/components/ModalConfirm.vue";
import "@vueform/multiselect/themes/default.css";
import MaterialInput from "@/components/MaterialInput.vue";
import Multiselect from "@vueform/multiselect";
import $ from "jquery";
import TokenService from "../../../services/token.service";
import MaterialRadio from "@/components/MaterialRadio.vue";
import PosStaffService from "../../../services/posStaff.service";
import { scrollToFirstInvalid } from "@/config/utils";

export default {
  name: "pos-staff",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    ModalConfirm,
    Pagination,
    MaterialInput,
    MaterialRadio,
    Multiselect,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      staffs: [],
      searchKeyword: "",
      role: [
        {
          value: "Cashier",
          label: "Cashier",
        },
        {
          value: "Manager",
          label: "Manager",
        },
      ],
      pagination: {},
      page: 1,
      methodId: null,
      isLoadData: false,
      labelGroup: "ADD NEW STAFF",
      urlImagePreview: null,
      image: null,
      messageImageError: "",
      isErrorUploadImage: false,
      isImageTooSmall: false,
      dataStaff: {
        id: 0,
        staff_id: "",
        name: "",
        job_title: "",
        is_internal_only: 0,
        phone_number: "",
        appointment_gap_min: "",
        status: 0,
        work_schedule: [],
        // SH030 — the services this staff member is able to perform. Empty is the normal
        // state and means "not restricted", not "can do nothing".
        service_item_ids: [],
      },
      // SH030 — the merchant's whole service menu, fetched once for the screen rather
      // than per dialog: it is the same list for every staff member on it. Each entry
      // carries the menu set it belongs to, so choosing a set is a filter the dialog
      // already holds rather than another request per click.
      serviceCatalog: [],
      menuSets: [],
      selectedSetId: null,
      serviceSearch: "",
      isLoadingServices: false,
      // SH008 — Sunday first, so the numbering lines up with the API's 0-6 (and with
      // minty_branch_operation_days, which the availability check compares against).
      weekDays: [
        { value: 0, label: "Sunday" },
        { value: 1, label: "Monday" },
        { value: 2, label: "Tuesday" },
        { value: 3, label: "Wednesday" },
        { value: 4, label: "Thursday" },
        { value: 5, label: "Friday" },
        { value: 6, label: "Saturday" },
      ],
      // SH029 — the same numbers MintyPosStaffWorkDay uses, and the same ones the sale
      // channel's operating hours use, so a period type never has to be translated.
      PERIOD: {
        WORK_PERIOD: 1,
        WORK_ALL_DAY: 2,
        DAY_OFF: 3,
      },
      periodTypes: [
        { value: 1, label: "Work Period" },
        { value: 2, label: "Work All Day" },
        { value: 3, label: "Day Off" },
      ],
      imagePreview: "",
      photoFile: null,
      removeExistingPhoto: false,
      fieldRequired: {},
      textRequireStaffNameCustom: "",
      textRequireStaffIdCustom: "",
      textRequireStaffEmailCustom: "",
      textRequireStaffPhoneNoCustom: "",
      textRequireWorkScheduleCustom: "",
      workScheduleErrorDay: null,
      action_export: "csv",
      actionDownload: process.env.VUE_APP_BASE_URL,
      token: TokenService.getLocalAccessToken(),
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCodeExport: localStorage.getItem("MERCHANT_CODE", ""),
    };
  },
  mounted() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getList(this.page);
    this.getServiceCatalog();
  },
  computed: {
    /**
     * SH030 — the picker's rows: the catalogue narrowed by the search box and grouped
     * under its category headings, in the order the API sent them (category, then name).
     *
     * A ticked service always survives the filter. Typing in the box must not hide what
     * the merchant already chose — a list that shrank to five rows while eleven were
     * ticked would read as though the other six had been dropped.
     */
    serviceGroups() {
      if (!this.selectedSetId) {
        return [];
      }

      const keyword = this.serviceSearch.trim().toLowerCase();
      const groups = [];
      let current = null;

      for (const service of this.serviceCatalog) {
        if (service.set_id !== this.selectedSetId) {
          continue;
        }

        const matches =
          !keyword ||
          service.name.toLowerCase().includes(keyword) ||
          service.category_name.toLowerCase().includes(keyword) ||
          this.dataStaff.service_item_ids.includes(service.item_id);

        if (!matches) {
          continue;
        }

        if (!current || current.name !== service.category_name) {
          current = { name: service.category_name, services: [] };
          groups.push(current);
        }

        current.services.push(service);
      }

      return groups;
    },

    /** Whether the chosen menu set has any service at all, before the search narrows it. */
    hasServicesInSet() {
      return this.serviceCatalog.some(
        (service) => service.set_id === this.selectedSetId
      );
    },

    // The dropdown's own options. Every set the merchant has, including the empty ones:
    // a set missing from the list and a set with nothing in it look identical otherwise,
    // and only one of them is a problem the merchant can fix.
    menuSetOptions() {
      return this.menuSets.map((set) => ({ value: set.id, label: set.name }));
    },

    selectedServiceCount() {
      return this.dataStaff.service_item_ids.length;
    },

    // Counted across menu sets, like the selection itself: a service sold in two sets is
    // one service a stylist either can or cannot perform, and it is stored once.
    totalServiceCount() {
      return new Set(this.serviceCatalog.map((service) => service.item_id)).size;
    },
  },
  methods: {
    exportFile(type = "csv") {
      this.action_export = type;
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    getList(page) {
      this.isLoadData = false;
      this.staffs = [];
      var dataForm = {
        search_keyword: this.searchKeyword,
        page: page,
      };
      PosStaffService.getList(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.staffs = response.data.data.items;
            this.pagination = response.data.data;
            this.page = this.pagination.current_page;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    saveStaff() {
      if (this.processValidate()) {
        if (!this.dataStaff.id) {
          this.showLoader();
          PosStaffService.store(this.staffPayload()).then(
            (response) => {
              if (response.data.result.isSuccess) {
                this.snackbar = "success";
                this.message = "Save Staff Success";
                this.setTimeOutNotification();
                $(".btn-close-modal").click();
                this.page = 1;
                this.searchKeyword = '';
                this.getList(this.page);
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              this.hideLoader();
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        } else {
          PosStaffService.update(this.staffPayload()).then(
            (response) => {
              if (response.data.result.isSuccess) {
                this.snackbar = "success";
                this.message = "Update Staff Success";
                this.setTimeOutNotification();
                $(".btn-close-modal").click();
                this.searchKeyword = '';
                this.getList(this.page);
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              this.hideLoader();
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        }
      }
    },

    // SH008 — what actually goes on the wire. work_days travels as an array, the photo
    // as a File, and an empty gap is omitted entirely: the API reads a missing value as
    // "inherit the sale channel's", while "" would be cast to 0 — "no gap at all".
    staffPayload() {
      const payload = {
        id: this.dataStaff.id,
        staff_id: this.dataStaff.staff_id,
        name: this.dataStaff.name,
        job_title: this.dataStaff.job_title ?? "",
        // SH036 — the radio hands back a string; the API only accepts 0 or 1.
        is_internal_only: Number(this.dataStaff.is_internal_only) === 1 ? 1 : 0,
        phone_number: this.dataStaff.phone_number,
        status: this.dataStaff.status,
        // SH029 — one JSON string rather than nested form fields: the request is
        // multipart so the photo can travel with it, and a nested array's multipart
        // serialisation is not something the schedule should depend on.
        work_schedule: JSON.stringify(
          (this.dataStaff.work_schedule ?? []).map((day) => ({
            day_of_week: day.day_of_week,
            period_type: day.period_type,
            work_hours:
              day.period_type === this.PERIOD.WORK_PERIOD
                ? day.work_hours.map((hour) => ({
                    start_time: hour.start_time,
                    end_time: hour.end_time,
                  }))
                : [],
          }))
        ),
      };

      // SH030 — a JSON string for the same reason as work_schedule above, plus one of its
      // own: an empty array is a real answer here ("no restriction"), and multipart drops
      // an empty `service_item_ids[]` altogether, which the API reads as "not sent".
      payload.service_item_ids = JSON.stringify(
        this.dataStaff.service_item_ids ?? []
      );

      const gap = this.dataStaff.appointment_gap_min;

      if (gap !== "" && gap !== null && gap !== undefined) {
        payload.appointment_gap_min = gap;
      }

      if (this.photoFile) {
        payload.image = this.photoFile;
      } else if (this.removeExistingPhoto) {
        payload.remove_image = 1;
      }

      return payload;
    },

    // SH029 — the seven rows the schedule table draws when nobody has configured this
    // staff member yet. Work All Day throughout, which is what the API reads an empty
    // schedule as: works whenever the sale channel is open.
    defaultWorkSchedule() {
      return this.weekDays.map((day) => ({
        day_of_week: day.value,
        day_name: day.label,
        period_type: this.PERIOD.WORK_ALL_DAY,
        work_hours: [],
      }));
    },

    // The saved schedule, filled out to seven rows. A day the API did not send keeps the
    // default rather than dropping out of the table.
    hydrateWorkSchedule(schedule) {
      const saved = Array.isArray(schedule) ? schedule : [];

      return this.defaultWorkSchedule().map((row) => {
        const day = saved.find(
          (item) => Number(item.day_of_week) === row.day_of_week
        );

        if (!day) {
          return row;
        }

        return {
          day_of_week: row.day_of_week,
          day_name: day.day_name ?? row.day_name,
          period_type: Number(day.period_type) || this.PERIOD.WORK_ALL_DAY,
          work_hours: (day.work_hours ?? []).map((hour) => ({
            start_time: hour.start_time ?? "",
            end_time: hour.end_time ?? "",
          })),
        };
      });
    },

    // SH030 — the merchant's service menu. Failing to load it is not worth a red bar over
    // the staff list: the rest of the dialog still works, and the section says so itself.
    getServiceCatalog() {
      this.isLoadingServices = true;
      PosStaffService.getServices().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.serviceCatalog = response.data.data.services ?? [];
            this.menuSets = response.data.data.menu_sets ?? [];
            this.resetServiceSet();
          }
          this.isLoadingServices = false;
        },
        () => {
          this.isLoadingServices = false;
        }
      );
    },

    // Back to the first step. A merchant with exactly one menu set has nothing to choose
    // between, so the step would be a click that can only be answered one way.
    resetServiceSet() {
      this.selectedSetId = this.menuSets.length === 1 ? this.menuSets[0].id : null;
      this.serviceSearch = "";
    },

    // Each set is searched on its own: carrying a keyword across sets would silently
    // narrow a set the merchant has only just opened.
    onMenuSetChange() {
      this.serviceSearch = "";
    },

    isServiceSelected(itemId) {
      return this.dataStaff.service_item_ids.includes(itemId);
    },

    toggleService(itemId) {
      const index = this.dataStaff.service_item_ids.indexOf(itemId);

      if (index === -1) {
        this.dataStaff.service_item_ids.push(itemId);
        return;
      }

      this.dataStaff.service_item_ids.splice(index, 1);
    },

    isGroupSelected(group) {
      return group.services.every((service) =>
        this.isServiceSelected(service.item_id)
      );
    },

    // One click for a whole category, because that is how a salon thinks about it: a
    // colourist does colour. Ticks the category when any of it is still unticked, and
    // clears it only once the whole category is on.
    toggleGroup(group) {
      const selectAll = !this.isGroupSelected(group);

      for (const service of group.services) {
        const selected = this.isServiceSelected(service.item_id);

        if (selectAll && !selected) {
          this.dataStaff.service_item_ids.push(service.item_id);
        } else if (!selectAll && selected) {
          this.toggleService(service.item_id);
        }
      }
    },

    // Back to "not restricted". Deliberately worded as clearing rather than as
    // unticking everything: an empty list is what lets this staff member do the lot.
    clearServices() {
      this.dataStaff.service_item_ids = [];
    },

    addWorkPeriod(dayIndex) {
      this.dataStaff.work_schedule[dayIndex].work_hours.push({
        start_time: "",
        end_time: "",
      });
    },

    removeWorkPeriod(dayIndex, hourIndex) {
      this.dataStaff.work_schedule[dayIndex].work_hours.splice(hourIndex, 1);
    },

    onPhotoChange(event) {
      const file = event.target.files && event.target.files[0];
      this.messageImageError = "";

      if (!file) {
        return;
      }

      // Matches the API's 'image|max:5120' rule, so an oversized file is refused here
      // rather than after a slow upload.
      if (file.size > 5 * 1024 * 1024) {
        this.messageImageError = "Photo must be 5MB or smaller.";
        event.target.value = "";
        return;
      }

      this.photoFile = file;
      this.removeExistingPhoto = false;
      this.imagePreview = URL.createObjectURL(file);
    },

    removePhoto() {
      this.photoFile = null;
      this.imagePreview = "";
      this.removeExistingPhoto = true;
      this.messageImageError = "";

      if (this.$refs.staffPhoto) {
        this.$refs.staffPhoto.value = "";
      }
    },

    resetPhotoState() {
      this.photoFile = null;
      this.imagePreview = "";
      this.removeExistingPhoto = false;
      this.messageImageError = "";

      if (this.$refs.staffPhoto) {
        this.$refs.staffPhoto.value = "";
      }
    },

    resetRequired() {
      this.fieldRequired.isStaffIdRequire = false;
      this.fieldRequired.isStaffNameRequire = false;
      this.fieldRequired.isStaffPhoneNoRequire = false;
      this.workScheduleErrorDay = null;
    },

    processValidate() {
      this.resetRequired();
      var isValid = true;
      if (this.dataStaff.staff_id == "" || this.dataStaff.staff_id == null) {
        this.fieldRequired.isStaffIdRequire = true;
        this.textRequireStaffIdCustom = "The field is required.";
        isValid = false;
      }

      if (this.dataStaff.name == "" || this.dataStaff.name == null) {
        this.fieldRequired.isStaffNameRequire = true;
        this.textRequireStaffNameCustom = "The field is required.";
        isValid = false;
      }

      if (
        this.dataStaff.phone_number == "" ||
        this.dataStaff.phone_number == null
      ) {
        this.fieldRequired.isStaffPhoneNoRequire = true;
        this.textRequireStaffPhoneNoCustom = "The field is required.";
        isValid = false;
      }

      // SH029 — a day worked by period has to say which hours. Left half-filled it would
      // be dropped on save and the day would silently become an all-day one.
      const scheduleError = this.workScheduleError();

      if (scheduleError) {
        this.workScheduleErrorDay = scheduleError.day_of_week;
        this.textRequireWorkScheduleCustom = scheduleError.message;
        isValid = false;
      }

      if (!isValid) {
        scrollToFirstInvalid();
      }

      return isValid;
    },

    /**
     * The first day whose periods are unusable, with what is wrong with it, or null when
     * the schedule is fine. The day travels with the message so it can be printed in that
     * day's own row — scrollToFirstInvalid() rings whichever control sits nearest the
     * message, which is the wrong row's dropdown if the message hangs under the table.
     */
    workScheduleError() {
      for (const day of this.dataStaff.work_schedule ?? []) {
        if (day.period_type !== this.PERIOD.WORK_PERIOD) {
          continue;
        }

        const fail = (message) => ({ day_of_week: day.day_of_week, message });

        if (!day.work_hours.length) {
          return fail("Add a period, or choose Work All Day / Day Off.");
        }

        for (const hour of day.work_hours) {
          if (!hour.start_time || !hour.end_time) {
            return fail("Both a start time and an end time are needed.");
          }

          if (hour.start_time === hour.end_time) {
            return fail("The start time and end time cannot be the same.");
          }
        }
      }

      return null;
    },

    isPositiveInteger(str) {
      return parseFloat(str) > 0;
    },

    addStaff() {
      this.labelGroup = "ADD NEW STAFF";
      this.dataStaff.id = 0;
      this.dataStaff.staff_id = "";
      this.dataStaff.name = "";
      this.dataStaff.job_title = "";
      this.dataStaff.is_internal_only = 0;
      this.dataStaff.phone_number = "";
      this.dataStaff.appointment_gap_min = "";
      this.dataStaff.status = 0;
      this.dataStaff.work_schedule = this.defaultWorkSchedule();
      this.dataStaff.service_item_ids = [];
      this.resetServiceSet();
      this.resetPhotoState();
      const modalAdd = document.getElementById("action-group");
      modalAdd.click();
      this.resetRequired();
    },

    async editStaff(methodId) {
      this.resetRequired();
      this.isLoadDoneData = false;
      this.showLoader();
      await PosStaffService.detail(methodId).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const staff = response.data.data;
            this.isLoadDoneData = true;
            this.dataStaff.id = staff.id ?? 0;
            this.dataStaff.staff_id = staff.staff_id ?? "";
            this.dataStaff.name = staff.name ?? "";
            this.dataStaff.job_title = staff.job_title ?? "";
            this.dataStaff.is_internal_only =
              Number(staff.is_internal_only) === 1 ? 1 : 0;
            this.dataStaff.phone_number = staff.phone_number ?? "";
            // null means "inherit the sale channel's gap" — it must stay blank in the
            // box, not become a 0 the merchant never typed.
            this.dataStaff.appointment_gap_min =
              staff.appointment_gap_min === null ||
              staff.appointment_gap_min === undefined
                ? ""
                : staff.appointment_gap_min;
            this.dataStaff.status = staff.status ?? 0;
            this.dataStaff.work_schedule = this.hydrateWorkSchedule(
              staff.work_schedule
            );
            this.dataStaff.service_item_ids = (
              staff.service_item_ids ?? []
            ).map((id) => Number(id));
            this.resetServiceSet();
            this.resetPhotoState();
            this.imagePreview = staff.image ?? "";
            this.labelGroup = `EDIT STAFF`;
            const editStaff = document.getElementById("action-group");
            editStaff.click();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getList(this.page);
      }, 1000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>
<style scoped>
/* SH008 — service staff setup */
.staff-photo-preview {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #dee2e6;
}

/* SH030 — the service picker. A salon menu runs to hundreds of items, so the list scrolls
   inside its own box: letting it grow would push Save off the bottom of the dialog. */
.staff-service-list {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 6px 10px;
}

.staff-service-group + .staff-service-group {
  margin-top: 8px;
}

/* Sticky so the category a merchant is scrolling through keeps saying what it is. */
.staff-service-group-head {
  position: sticky;
  top: -6px;
  background: #fff;
  padding: 4px 0;
  font-size: 12px;
  z-index: 1;
}

.staff-service-row {
  padding-left: 0;
  margin-bottom: 2px;
}

.staff-service-row .form-check-input {
  margin-top: 2px;
}

.staff-service-row .custom-control-label {
  font-size: 13px;
  cursor: pointer;
}

.staff-service-hint {
  color: #7b809a;
}

/* SH029 — work schedule, sized to sit inside the staff dialog rather than a full page. */
.work-schedule-table th {
  padding: 4px 6px;
  font-size: 12px;
  text-transform: none;
}

.work-schedule-table td {
  padding: 4px 6px;
  font-size: 13px;
}

/* The three columns are sized so the widest row — a dropdown, two time boxes and the
   remove icon — still fits the dialog, which is half the width of the sale channel page
   this table is modelled on. */
.work-schedule-table .col-day {
  width: 78px;
}

.work-schedule-table .col-type {
  width: 170px;
}

.work-schedule-table :deep(.multiselect) {
  min-width: 160px;
  font-size: 13px;
}

.work-time {
  width: 100px;
  padding: 2px 4px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 12px;
}

.text-title {
  color: #133067 !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.text-label {
  color: #5b848d !important;
  font-weight: 500 !important;
  font-size: 17px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.checkbox-auto-save label {
  padding-top: 11px !important;
}

.custom-name {
  word-break: break-all;
  max-width: 200px;
  white-space: normal;
}

.wrap-action .form-check:first-child {
  padding-left: 2px;
}

.multiselect {
  min-width: 135px;
}

.r-no-expiry .form-check {
  padding-left: 0 !important;
}

#preview img {
  width: 120px;
  height: 60px;
  object-fit: cover;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

input.nosubmit {
  border: none;
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

@media (min-width: 576px) {
  /* SH029 — widened from 50%: the schedule row has to hold a dropdown, two time boxes
     and a remove button on one line, which the old width could not fit. */
  .modal-dialog {
    max-width: 60%;
    margin: 1.75rem auto;
  }
}
</style>
